.relatedLink {
    margin: 20px;
}
.relatedLink .title {
    height: 57px;
    width: 168px;
    background-image: url(../common/assets/theme/images/related_link.png);
}
.relatedLink .title span {
    display: none;
}
.relatedLink .links li {
    line-height: 2;
}
.relatedLink .links li a {
    font-size: 95%;
    color: #333333;
}
.relatedLink .links li a:hover {
    color: #62c2c2;
}
